import { createModel, RematchDispatch } from '@rematch/core';
import * as ThemeService from '../../services/theme.service';
import { PaginationType } from '../../types/CommonTypes';
import { ThemeData } from '../../types/ThemeData';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'themeEntity';

export const themeEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof themeEntity>) => ({
    async loadById(id, state): Promise<ThemeData> {
      try {
        const { data } = await ThemeService.getTheme(id);
        this.saves([data]);
        return data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async load(params): Promise<{ content?: ThemeData[] } & PaginationType> {
      try {
        const res = await ThemeService.filterThemes(params);
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(payload) {
      try {
        await ThemeService.deleteTheme(payload);
        this.remove(payload);
      } catch (e) {
        throw new Error(e);
      }
    },
    async create(payload) {
      try {
        const { data: item } = await ThemeService.createTheme(payload);
        this.saves([item]);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
    async update(payload) {
      try {
        const { data: item } = await ThemeService.updateTheme(payload);
        this.saves([item]);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default themeEntity;
